import { Phone, Mail, MapPin, Star, Facebook } from "lucide-react";
import { BUSINESS } from "@/data/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-black border-t border-zinc-900">
      <div className="mx-auto max-w-7xl px-5 md:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center bg-red-600">
                <Star className="h-5 w-5 text-white" fill="white" />
              </span>
              <span className="leading-none">
                <span className="block font-heading text-xl tracking-wide text-white">PRECISION</span>
                <span className="block text-[10px] font-bold tracking-[0.3em] text-red-500 uppercase">Handyman Services</span>
              </span>
            </div>
            <p className="mt-5 text-sm text-zinc-500 leading-relaxed max-w-xs">
              Veteran owned & operated. Built on honor, driven by integrity, backed by experience.
            </p>
            <a
              href={BUSINESS.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
              className="mt-5 inline-flex items-center gap-2 border border-zinc-800 bg-zinc-900/60 px-4 py-2.5 text-sm font-bold uppercase tracking-widest text-zinc-100 hover:border-red-600 hover:text-red-500 transition-colors duration-150"
            >
              <Facebook className="h-4 w-4" /> Follow Us
            </a>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.25em] text-zinc-400 mb-5">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={BUSINESS.phoneHref} className="flex items-center gap-3 text-zinc-300 hover:text-red-500 transition-colors duration-150">
                  <Phone className="h-4 w-4 text-red-500" /> {BUSINESS.phone}
                </a>
              </li>
              <li>
                <a href={BUSINESS.emailHref} className="flex items-center gap-3 text-zinc-300 hover:text-red-500 transition-colors duration-150">
                  <Mail className="h-4 w-4 text-red-500" /> {BUSINESS.email}
                </a>
              </li>
              <li className="flex items-center gap-3 text-zinc-300">
                <MapPin className="h-4 w-4 text-red-500" /> {BUSINESS.serviceArea}
              </li>
              <li>
                <a href={BUSINESS.facebook} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-zinc-300 hover:text-red-500 transition-colors duration-150">
                  <Facebook className="h-4 w-4 text-red-500" /> Facebook
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.25em] text-zinc-400 mb-5">Quick Links</h4>
            <ul className="space-y-3 text-sm">
              {[
                { label: "Services", href: "#services" },
                { label: "Recent Work", href: "#work" },
                { label: "About", href: "#about" },
                { label: "Free Estimate", href: "#contact" },
              ].map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-zinc-300 hover:text-red-500 transition-colors duration-150">{l.label}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-zinc-900">
        <div className="mx-auto max-w-7xl px-5 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-zinc-600">© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</p>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-zinc-600">Precision In Every Detail</p>
        </div>
      </div>
    </footer>
  );
};
